"use strict";

/*
    Rolagem sinconizada
*/
$(".one_scroll").scroll(function () {
    $(".two_scroll").scrollLeft($(".one_scroll").scrollLeft());
});

$(".two_scroll").scroll(function () {
    $(".one_scroll").scrollLeft($(".two_scroll").scrollLeft());
});

/*
    Esconde as colunas de qtd ao carregar a página
*/
$('.visao_qtd').hide();

/*
    Formas de visualização
*/
$('input[name="visualizacao"]').on('ifClicked', function (event) {
    startLoading();

    if (this.value == 'ambos') {
        $('.visao_valor').show();
        $('.visao_qtd').show();

        $('.th_1_2').attr('colspan', 2);
    } else if (this.value == 'qtd') {
        $('.visao_qtd').show();
        $('.visao_valor').hide();

        $('.th_1_2').attr('colspan', 1);
    } else {
        $('.visao_valor').show();
        $('.visao_qtd').hide();

        $('.th_1_2').attr('colspan', 1);
    }

    setTimeout(function () {
        $('.itens_colunas').each(function (index, value) {
            if (value.classList.contains("active")) {
                ocultarColuna(value.getAttribute('data-coluna'));
            }
        });

        stopLoading();
    }, 100);
});

/*
    Filtros de tipos de insumo
*/
$('#insumos_de_material').on('ifClicked', function (event) {
    if ($('#insumos_de_material').val() > 0) {
        $('#insumos_de_material').val(0);
    } else {
        $('#insumos_de_material').val(1);
    }

    filter(null, $('#insumos_de_material'));
});

$('#insumos_de_servico').on('ifClicked', function (event) {
    if ($('#insumos_de_servico').val() > 0) {
        $('#insumos_de_servico').val(0);
    } else {
        $('#insumos_de_servico').val(1);
    }

    filter(null, $('#insumos_de_servico'));
});

/*
    Modais
*/
$("#modal-obs").on('shown.bs.modal', function () {
    $(this).find('#text_area_obs').focus();
});

$("#modal-justificativa").on('shown.bs.modal', function () {
    $(this).find('#text_area_justificativa').focus();
});

/*
    Processa os filtros da gerencial
*/
function filter() {
    var change = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var el = arguments[1];

    startLoading();

    var queryString = '';
    var obra_id = $('#obra_id').val();
    var tipo_orcamento = $('#tipo_orcamento').val();
    var gerencial_id = $('#gerencial_id').val();
    var grupo_id = $('#grupo_id').val();
    var insumos_de_material = $('#insumos_de_material').val();
    var data = $('#data').val();
    var insumos_de_servico = $('#insumos_de_servico').val();
    var subgrupo = $('#subgrupo').val();
    var servico = $('#servico').val();
    var insumo = $('#insumo').val();
    var insumo_id = $('#insumo_id').val();
    var carteira = $('#carteira').val();
    var fornecedor_id = $('#fornecedor_id').val();
    var probabilidade = $('#probabilidade').val();
    var tipo_de_risco = $('#tipo_de_risco').val();
    var responsavel = $('#responsavel').val();
    var data_prevista = $('#data_prevista').val();
    var status = $('#status').val() === undefined ? false : $('#status').val();

    if ($(el).attr('name') == 'obra_id') {
        queryString = '?obra_id=' + obra_id;
        return window.location.href = location.pathname + queryString;
    } else if (obra_id > 0) {
        queryString = '?obra_id=' + obra_id;
    }

    if (probabilidade) {
        if (queryString.length > 0) {
            queryString += '&';
        } else {
            queryString += '?';
        }
        queryString += 'probabilidade=' + probabilidade;
    }

    if (tipo_de_risco) {
        if (queryString.length > 0) {
            queryString += '&';
        } else {
            queryString += '?';
        }
        queryString += 'tipo_de_risco=' + tipo_de_risco;
    }

    if (responsavel) {
        if (queryString.length > 0) {
            queryString += '&';
        } else {
            queryString += '?';
        }
        queryString += 'responsavel=' + responsavel;
    }

    if (data_prevista) {
        if (queryString.length > 0) {
            queryString += '&';
        } else {
            queryString += '?';
        }
        queryString += 'data_prevista=' + data_prevista;
    }

    if (status) {
        if (queryString.length > 0) {
            queryString += '&';
        } else {
            queryString += '?';
        }
        queryString += 'status=' + status;
    }

    if (gerencial_id) {
        if (queryString.length > 0) {
            queryString += '&';
        } else {
            queryString += '?';
        }
        queryString += 'gerencial_id=' + gerencial_id;
    }

    if (tipo_orcamento) {
        if (queryString.length > 0) {
            queryString += '&';
        } else {
            queryString += '?';
        }
        queryString += 'tipo_orcamento=' + tipo_orcamento;
    }

    if (data) {
        if (queryString.length > 0) {
            queryString += '&';
        } else {
            queryString += '?';
        }
        queryString += 'data=' + data;
    }

    if (obra_id > 0 && grupo_id > 0) {
        if (queryString.length > 0) {
            queryString += '&';
        } else {
            queryString += '?';
        }
        queryString += 'grupo_id=' + grupo_id;
    }

    if (obra_id > 0 && grupo_id > 0 && subgrupo > 0 && change != 'grupos') {
        if (queryString.length > 0) {
            queryString += '&';
        } else {
            queryString += '?';
        }
        queryString += 'subgrupo=' + subgrupo;
    }

    if (obra_id > 0 && grupo_id > 0 && subgrupo > 0 && servico > 0 && change != 'grupos' && change != 'subgrupos') {
        if (queryString.length > 0) {
            queryString += '&';
        } else {
            queryString += '?';
        }
        queryString += 'servico=' + servico;
    }

    if (insumo > 0) {
        if (queryString.length > 0) {
            queryString += '&';
        } else {
            queryString += '?';
        }
        queryString += 'insumo=' + insumo;
    }

    if (carteira > 0) {
        if (queryString.length > 0) {
            queryString += '&';
        } else {
            queryString += '?';
        }
        queryString += 'carteira=' + carteira;
    }

    if (insumos_de_material > 0) {
        if (queryString.length > 0) {
            queryString += '&';
        } else {
            queryString += '?';
        }
        queryString += 'insumos_de_material=' + insumos_de_material;
    }

    if (fornecedor_id) {
        if (queryString.length > 0) {
            queryString += '&';
        } else {
            queryString += '?';
        }

        queryString += 'fornecedor_id=' + fornecedor_id;
    }

    if (insumos_de_servico > 0) {
        if (queryString.length > 0) {
            queryString += '&';
        } else {
            queryString += '?';
        }
        queryString += 'insumos_de_servico=' + insumos_de_servico;
    }

    if (insumo_id > 0) {
        if (queryString.length > 0) {
            queryString += '&';
        } else {
            queryString += '?';
        }
        queryString += 'insumo_id=' + insumo_id;
    }

    return window.location.href = location.pathname + queryString;
    //history.pushState("", document.title, location.pathname + queryString);
    //location.reload();
}

/*
    Modal de visualização da observação do grupo
*/
function visualizarObsGrupo(id, acao) {
    obs = $('#obs_grupo_' + id).val();

    if (acao) {
        $('#text_area_obs').val(obs);
        $('#modal-obs').modal('show');
        $('#salvar_obs').attr('onclick', 'visualizarObsGrupo(' + id + ', 0);salvarObsGrupo(' + id + ')');
    } else {
        $('#obs_grupo_' + id).val($('#text_area_obs').val());
        $('#modal-obs').modal('hide');
    }
}

/*
    Modal de visualização da observação da apropriação
*/
function visualizarObs(id, acao) {
    obs = $('#obs_' + id).val();

    if (acao) {
        $('#text_area_obs').val(obs);
        $('#modal-obs').modal('show');
        $('#salvar_obs').attr('onclick', 'visualizarObs(' + id + ', 0);salvarObsJustificativa(' + id + ', "obs")');
    } else {
        $('#obs_' + id).val($('#text_area_obs').val());
        $('#modal-obs').modal('hide');
    }
}

/*
    Modal de visualização da justificativa da apropriação
*/
function visualizarJustificativa(id, acao) {
    justificativa = $('#justificativa_' + id).val();

    if (acao) {
        $('#text_area_justificativa').val(justificativa);
        $('#modal-justificativa').modal('show');
        $('#salvar_justificativa').attr('onclick', 'visualizarJustificativa(' + id + ', 0);salvarObsJustificativa(' + id + ', "justificativa")');
    } else {
        $('#justificativa_' + id).val($('#text_area_justificativa').val());
        $('#modal-justificativa').modal('hide');
    }
}

/*
    Abre e fecha o grupo trazendo as apropriações
*/
function openCloseApropriacoes(acao, buscar, gerencial_item_id, subgrupo2_id) {
    if (acao) {
        startLoading();
        if (buscar) {
            getApropriacoes(gerencial_item_id);
        } else {
            stopLoading();
        }

        $('#button_apropriacoes_td_' + gerencial_item_id).show();
        $('#button_apropriacoes_td_fixed_' + gerencial_item_id).show();
        $('#button_apropriacoes_' + gerencial_item_id).show();
        $('.tr_apropriacoes_' + gerencial_item_id + subgrupo2_id).css('display', '');
        $('.openClose' + gerencial_item_id + subgrupo2_id).attr('onclick', 'openCloseApropriacoes(0, 0, ' + gerencial_item_id + ', ' + subgrupo2_id + ')');
    } else {
        startLoading();

        $('#button_apropriacoes_td_' + gerencial_item_id).hide();
        $('#button_apropriacoes_td_fixed_' + gerencial_item_id).hide();
        $('#button_apropriacoes_' + gerencial_item_id).hide();
        $('.tr_apropriacoes_' + gerencial_item_id + subgrupo2_id).css('display', 'none');
        $('.openClose' + gerencial_item_id + subgrupo2_id).attr('onclick', 'openCloseApropriacoes(1, 0, ' + gerencial_item_id + ', ' + subgrupo2_id + ')');

        stopLoading();
    }
}

/*
    Calcula e salva o tipo de projeção da apropriação
*/
function calcularTipoProjecao(gerencial_item_insumo_id, tipo_projecao, ev) {

    // console.log(ev.parentNode.parentNode.parentNode);
    /*if (tipo_projecao == 'C') {
        if ($('#justificativa_' + gerencial_item_insumo_id).val() == '') {
            $('#tipo_projecao_' + gerencial_item_insumo_id).val('').select2();
            swal({
                title: 'Preencha a justificativa para fazer a projeção',
                text: '',
                type: 'info',
                allowOutsideClick: true,
                showCancelButton: false,
                showConfirmButton: false,
                timer: 2000
            });
             return false;
        }
    }*/
    var gerencial_item_id = $(ev).attr('data-gerencial-item-id');

    startLoading();
    $.ajax({
        method: "GET",
        url: "/gerencial/calcularTipoProjecao",
        data: {
            gerencial_item_insumo_id: gerencial_item_insumo_id, tipo_projecao: tipo_projecao,
            obra_id: $('#obra_id').val(),
            // gerencial_item_id: gerencial_item_id,
            gerencial_id: $('#gerencial_id').val(),
            subgrupo: $('#subgrupo').val(),
            servico: $('#servico').val(),
            insumo: $('#insumo').val(),
            carteira: $('#carteira').val(),
            // contrato: $('#subgrupo').val(),
            insumos_de_material: $('#insumos_de_material').val(),
            insumos_de_servico: $('#insumos_de_servico').val(),
            // data_anterior: $('#subgrupo').val(),
            // data_gerencial: $('#subgrupo').val(),
            // aberta: '{{$gerencial ? $gerencial->aberta : 0}}',
            offset: $('#button_apropriacoes_' + gerencial_item_id).data('offset')
        }
    }).done(function (rows) {

        var element = ev.parentNode.parentNode;
        do {
            element = $(element).prev();
        } while ($(element).attr('data-grupo-main') != 1);

        $('#a_gastar_qtd_obra').text(rows['obra']['a_gastar_qtd']);
        $('#a_gastar_valor_obra').text(rows['obra']['a_gastar_valor']);
        $('#tendencia_qtd_obra').text(rows['obra']['tendencia_atual_qtd']);
        $('#tendencia_valor_obra').text(rows['obra']['tendencia_atual_valor']);
        $('#tend_atual_x_tend_anterior_qtd_obra').text(rows['obra']['tend_atual_x_tend_anterior_qtd']);
        $('#tend_atual_x_tend_anterior_valor_obra').text(rows['obra']['tend_atual_x_tend_anterior_valor']);
        // Novos campos
        $('#tendencia_anterior_qtd_obra_obra').text(rows['obra']['tendencia_anterior_qtd']);
        $('#tendencia_anterior_valor_obra').text(rows['obra']['tendencia_anterior_valor']);

        $('#realizado_mes_qtd_obra').text(rows['obra']['realizado_mes_qtd']);
        $('#realizado_mes_valor_obra').text(rows['obra']['realizado_mes_valor']);

        $('#realizado_qtd_obra').text(rows['obra']['realizado_atual_qtd']);
        $('#realizado_valor_obra').text(rows['obra']['realizado_atual_valor']);

        $('#ordem_de_compra_qtd_obra').text(rows['obra']['ordem_de_compra_qtd']);
        $('#ordem_de_compra_valor_obra').text(rows['obra']['ordem_de_compra_valor']);

        $('#saldo_contrato_qtd_obra').text(rows['obra']['saldo_contrato_qtd']);
        $('#saldo_contrato_valor_obra').text(rows['obra']['saldo_contrato_valor']);

        $('#projecao_obra').text(rows['obra']['projecao']);
        $('#evolucao_fisica_obra').text(rows['obra']['evolucao_fisica']);

        $('#a_gastar_qtd_grupo_' + rows['grupo']['id']).text(rows['grupo']['a_gastar_qtd']);
        $('#a_gastar_valor_grupo_' + rows['grupo']['id']).text(rows['grupo']['a_gastar_valor']);
        $('#tendencia_qtd_grupo_' + rows['grupo']['id']).text(rows['grupo']['tendencia_atual_qtd']);
        $('#tendencia_valor_grupo_' + rows['grupo']['id']).text(rows['grupo']['tendencia_atual_valor']);
        $('#tend_atual_x_tend_anterior_qtd_grupo_' + rows['grupo']['id']).text(rows['grupo']['tend_atual_x_tend_anterior_qtd']);
        $('#tend_atual_x_tend_anterior_valor_grupo_' + rows['grupo']['id']).text(rows['grupo']['tend_atual_x_tend_anterior_valor']);
        $('#desvio_qtd_grupo_' + rows['grupo']['id']).text(rows['grupo']['desvio_qtd']);
        $('#desvio_valor_grupo_' + rows['grupo']['id']).text(rows['grupo']['desvio']);
        $('#tipo_projecao_grupo_' + rows['grupo']['id']).text(rows['grupo']['tipo_projecao']);

        //campos novos
        $('#tendencia_anterior_qtd_grupo_' + rows['grupo']['id']).text(rows['grupo']['tendencia_anterior_qtd']);
        $('#tendencia_anterior_valor_grupo_' + rows['grupo']['id']).text(rows['grupo']['tendencia_anterior_valor']);

        $('#realizado_mes_qtd_grupo_' + rows['grupo']['id']).text(rows['grupo']['realizado_mes_qtd']);
        $('#realizado_mes_valor_grupo_' + rows['grupo']['id']).text(rows['grupo']['realizado_mes_valor']);

        $('#realizado_atual_qtd_grupo_' + rows['grupo']['id']).text(rows['grupo']['realizado_atual_qtd']);
        $('#realizado_atual_valor_grupo_' + rows['grupo']['id']).text(rows['grupo']['realizado_atual_valor']);

        $('ordem_de_compra_qtd_grupo_' + rows['grupo']['id']).text(rows['grupo']['ordem_de_compra_qtd']);
        $('#ordem_de_compra_valor_grupo_' + rows['grupo']['id']).text(rows['grupo']['ordem_de_compra_valor']);

        $('#saldo_contrato_qtd_grupo_' + rows['grupo']['id']).text(rows['grupo']['saldo_contrato_qtd']);
        $('#saldo_contrato_valor_grupo_' + rows['grupo']['id']).text(rows['grupo']['saldo_contrato_valor']);

        $('#projecao_grupo_' + rows['grupo']['id']).html(rows['grupo']['projecao']);
        $('#evolucao_fisica_grupo_' + rows['grupo']['id']).text(rows['grupo']['evolucao_fisica']);

        $('#a_gastar_qtd_apropriacao_' + rows['apropriacao']['id']).text(rows['apropriacao']['a_gastar_qtd']);
        $('#a_gastar_valor_apropriacao_' + rows['apropriacao']['id']).text(rows['apropriacao']['a_gastar_valor']);
        $('#tendencia_qtd_apropriacao_' + rows['apropriacao']['id']).text(rows['apropriacao']['tendencia_atual_qtd']);
        $('#tendencia_valor_apropriacao_' + rows['apropriacao']['id']).text(rows['apropriacao']['tendencia_atual_valor']);
        $('#tend_atual_x_tend_anterior_qtd_apropriacao_' + rows['apropriacao']['id']).text(rows['apropriacao']['tend_atual_x_tend_anterior_qtd']);
        $('#tend_atual_x_tend_anterior_valor_apropriacao_' + rows['apropriacao']['id']).text(rows['apropriacao']['tend_atual_x_tend_anterior_valor']);
        $('#desvio_qtd_apropriacao_' + rows['apropriacao']['id']).text(rows['apropriacao']['desvio_qtd']);
        $('#desvio_valor_apropriacao_' + rows['apropriacao']['id']).text(rows['apropriacao']['desvio']);

        //campos novos
        $('#tendencia_anterior_qtd_apropriacao_' + rows['apropriacao']['id']).text(rows['apropriacao']['tendencia_anterior_qtd']);
        $('#tendencia_anterior_valor_apropriacao_' + rows['apropriacao']['id']).text(rows['apropriacao']['tendencia_anterior_valor']);

        $('#realizado_mes_qtd_apropriacao_' + rows['apropriacao']['id']).text(rows['apropriacao']['realizado_mes_qtd']);
        $('#realizado_mes_valor_apropriacao_' + rows['apropriacao']['id']).text(rows['apropriacao']['realizado_mes_valor']);

        $('#realizado_atual_qtd_apropriacao_' + rows['apropriacao']['id']).text(rows['apropriacao']['realizado_atual_qtd']);
        $('#realizado_atual_valor_apropriacao_' + rows['apropriacao']['id']).text(rows['apropriacao']['realizado_atual_valor']);

        $('ordem_de_compra_qtd_apropriacao_' + rows['apropriacao']['id']).text(rows['apropriacao']['ordem_de_compra_qtd']);
        $('#ordem_de_compra_valor_apropriacao_' + rows['apropriacao']['id']).text(rows['apropriacao']['ordem_de_compra_valor']);

        $('#saldo_contrato_qtd_apropriacao_' + rows['apropriacao']['id']).text(rows['apropriacao']['saldo_contrato_qtd']);
        $('#saldo_contrato_valor_apropriacao_' + rows['apropriacao']['id']).text(rows['apropriacao']['saldo_contrato_valor']);

        $('#projecao_apropriacao_' + rows['apropriacao']['id']).html(rows['apropriacao']['projecao']);
        $('#evolucao_fisica_apropriacao_' + rows['apropriacao']['id']).text(rows['apropriacao']['evolucao_fisica']);
        $('#classificacao_apropriacao_' + rows['apropriacao']['id']).html(rows['apropriacao']['classificacao']);
        $('.classificacao').select2();

        $(element).find('.coluna_a_gastar.visao_valor').text(rows['grupo_servico']['a_gastar_valor']);
        $(element).find('.coluna_a_gastar.visao_qtd').text(rows['grupo_servico']['a_gastar_qtd']);

        $(element).find('.coluna_tendencia.visao_valor').text(rows['grupo_servico']['tendencia_atual_valor']);
        $(element).find('.coluna_tendencia.visao_qtd').text(rows['grupo_servico']['tendencia_atual_qtd']);

        $(element).find('.coluna_tend_atual_x_tend_anterior.visao_valor').text(rows['grupo_servico']['tend_atual_x_tend_anterior_valor']);
        $(element).find('.coluna_tend_atual_x_tend_anterior.visao_qtd').text(rows['grupo_servico']['tend_atual_x_tend_anterior_qtd']);

        $(element).find('.coluna_desvio.visao_valor').text(rows['grupo_servico']['desvio_valor']);
        $(element).find('._oluna_desvio.visao_qtd').text(rows['grupo_servico']['desvio_qtd']);

        stopLoading();
    });
}

/*
    Salva a observação do grupo
*/
function salvarObsGrupo(gerencial_item_id) {
    startLoading();
    obs = $('#obs_grupo_' + gerencial_item_id).val();

    $.ajax({
        method: "GET",
        url: "/gerencial/salvarObsGrupo",
        data: { gerencial_item_id: gerencial_item_id, obs: obs }
    }).done(function () {
        if (obs == '') {
            $('#btn_obs_grupo_' + gerencial_item_id).removeClass('btn-warning').addClass('btn-default');
        } else {
            $('#btn_obs_grupo_' + gerencial_item_id).removeClass('btn-default').addClass('btn-warning');
        }
        stopLoading();
    });
}

/*
    Salva a classificacao da apropriação
*/
function salvarClassificacao(gerencial_item_insumo_id, classificacao) {
    startLoading();
    $.ajax({
        method: "GET",
        url: "/gerencial/salvarClassificacao",
        data: { gerencial_item_insumo_id: gerencial_item_insumo_id, classificacao: classificacao }
    }).done(function () {
        stopLoading();
    });
}

/*
    Salva a observação da apropriação
*/
function salvarObsJustificativa(gerencial_item_insumo_id, campo) {
    startLoading();
    if (campo == 'obs') {
        valor = $('#obs_' + gerencial_item_insumo_id).val();
    } else {
        valor = $('#justificativa_' + gerencial_item_insumo_id).val();
    }

    $.ajax({
        method: "GET",
        url: "/gerencial/salvarObsJustificativa",
        data: { gerencial_item_insumo_id: gerencial_item_insumo_id, campo: campo, valor: valor }
    }).done(function () {
        if (campo == 'obs') {
            if (valor == '') {
                $('#btn_obs_' + gerencial_item_insumo_id).removeClass('btn-warning').addClass('btn-default');
            } else {
                $('#btn_obs_' + gerencial_item_insumo_id).removeClass('btn-default').addClass('btn-warning');
            }
        } else {
            if (valor == '') {
                $('#btn_justificativa_' + gerencial_item_insumo_id).removeClass('btn-warning').addClass('btn-default');
            } else {
                $('#btn_justificativa_' + gerencial_item_insumo_id).removeClass('btn-default').addClass('btn-warning');
            }
        }

        stopLoading();
    });
}

/*
    Modal de detalhes de ordem de compra
*/
function detalhesOrdemDeCompra(codigo_insumo, gerencial_id, obra_id) {
    startLoading();
    $('.tr_oc').remove();

    $.ajax({
        url: '/gerencial/visualizacao/detalhes-de-ordem-de-compra',
        data: {
            codigo_insumo: codigo_insumo,
            gerencial_id: gerencial_id,
            obra_id: obra_id
        }
    }).done(function (retorno) {
        if (!retorno.itens.length) {
            swal('Nenhum registro encontrado!', 'Solicitar atualização da apropriação.', 'info');
            stopLoading();
            return false;
        }

        $.each(retorno.itens, function (index, item) {
            $('#tbody_oc').append('\
                    <tr class="tr_oc">\
                        <td>' + item.codigo_insumo + '</td>\
                        <td>' + item.insumo_nome + '</td>\
                        <td>' + item.unidade_de_medida + '</td>\
                        <td><a href="/ordens-de-compra/detalhes/' + item.id + '" target="_blank">' + item.id + '</a></td>\
                        <td>' + floatToMoney(item.qtd, "") + '</td>\
                        <td>' + floatToMoney(item.valor_unitario) + '</td>\
                        <td>' + floatToMoney(item.valor_total) + '</td>\
                    </tr>');

            if (index + 1 == retorno.itens.length) {
                stopLoading();
                $('#modal-detalhes-ordem-de-compra').modal('show');
            }
        });
    });
}

/*
    Modal de detalhes de contrato
*/
function detalhesContrato(codigo_insumo, gerencial_id, obra_id) {
    startLoading();
    $('.tr_contrato').remove();

    $.ajax({
        url: '/gerencial/visualizacao/detalhes-de-contrato',
        data: {
            codigo_insumo: codigo_insumo,
            gerencial_id: gerencial_id,
            obra_id: obra_id
        }
    }).done(function (retorno) {
        if (!retorno.itens.length) {
            swal('Nenhum registro encontrado!', 'Solicitar atualização da apropriação.', 'info');
            stopLoading();
            return false;
        }

        $.each(retorno.itens, function (index, item) {
            var valor_contratado = (item.qtd - moneyToFloat(item.realizado_qtd.replace('.', ','))) * item.valor_unitario + moneyToFloat(item.realizado_valor.replace('.', ','));
            var saldo_qtd = item.qtd - item.realizado_qtd;
            var saldo_valor = valor_contratado - item.realizado_valor;

            $('#tbody_contrato').append('\
                    <tr class="tr_contrato">\
                        <td>' + item.codigo_insumo + '</td>\
                        <td>' + item.insumo_nome + '</td>\
                        <td>' + item.unidade_de_medida + '</td>\
                        <td><a href="/contratos/' + item.id + '" target="_blank">' + item.contrato_nome + '</a></td>\
                        <td>' + floatToMoney(parseFloat(item.qtd), "") + '</td>\
                        <td>' + floatToMoney(valor_contratado) + '</td>\
                        <td>' + floatToMoney(moneyToFloat(item.realizado_qtd.replace('.', ',')), "") + '</td>\
                        <td>' + floatToMoney(moneyToFloat(item.realizado_valor.replace('.', ','))) + '</td>\
                        <td>' + floatToMoney(saldo_qtd, "") + '</td>\
                        <td>' + floatToMoney(parseFloat(item.valor_unitario)) + '</td>\
                        <td>' + floatToMoney(saldo_valor) + '</td>\
                    </tr>');

            if (index + 1 == retorno.itens.length) {
                stopLoading();
                $('#modal-detalhes-contrato').modal('show');
            }
        });
    });
}

/*
    Modal de detalhes de realizado no mês
*/
function detalhesRealizadoMes(codigo_insumo, mes_realizado, obra_id) {
    startLoading();

    $('.tr_realizado_mes').remove();

    $.ajax({
        url: '/gerencial/visualizacao/detalhes-de-realizado-mes',
        data: {
            codigo_insumo: codigo_insumo,
            obra_id: obra_id,
            mes_realizado: mes_realizado
        }
    }).done(function (retorno) {
        if (!retorno.itens.length) {
            swal('Nenhum registro encontrado!', '', 'error');
            stopLoading();
            return false;
        }

        $.each(retorno.itens, function (index, item) {
            type = item.type == 'M' ? 'notasfiscais' : 'notasfiscaisservicos';
            $('#tbody_realizado_mes').append('\
                    <tr class="tr_realizado_mes">\
                        <td>' + item.codigo_insumo + '</td>\
                        <td>' + item.insumo_nome + '</td>\
                        <td>' + item.unidade_de_medida + '</td>\
                        <td>' + item.data_competencia + '</td>\
                        <td><a href="/' + type + '/' + item.nf_id + '/edit" target="_blank">' + item.numero_nf + '</a></td>\
                        <td>' + item.fornecedor + '</td>\
                        <td>' + item.qtd + '</td>\
                        <td>' + item.valor_unitario + '</td>\
                        <td>' + item.valor_total + '</td>\
                    </tr>');

            if (index + 1 == retorno.itens.length) {
                stopLoading();
                $('#modal-detalhes-realizado-mes').modal('show');
            }
        });
    });
}

/*
    Modal de detalhes de realizado
*/
function detalhesRealizado(codigo_insumo, gerencial_id, obra_id) {
    startLoading();

    $('.tr_realizado').remove();

    $.ajax({
        url: '/gerencial/visualizacao/detalhes-de-realizado',
        data: {
            codigo_insumo: codigo_insumo,
            gerencial_id: gerencial_id,
            obra_id: obra_id
        }
    }).done(function (retorno) {
        $.each(retorno.itens, function (index, item) {
            $('#tbody_realizado').append('\
                    <tr class="tr_realizado">\
                        <td>' + item.codigo_insumo + '</td>\
                        <td>' + item.insumo_nome + '</td>\
                        <td>' + item.unidade_de_medida + '</td>\
                        <td>' + item.mes + '</td>\
                        <td>' + item.qtd + '</td>\
                        <td>' + item.valor_total + '</td>\
                        <td onclick=modalRealizados("' + item.insumo_detalhes + '","' + item.mes_detalhes + '","' + item.obra_detalhes + '") style="cursor:pointer"><button class="btn btn-sm btn-primary"><i class="fa fa-plus"></i></button></td>\
                    </tr>');

            if (index + 1 == retorno.itens.length) {
                stopLoading();
                $('#modal-detalhes-realizado').modal('show');
            }
        });
    });
}

/*
    Sincronização dos modais de realizado
*/
function modalRealizados(codigo_insumo, mes_realizado, obra_id) {
    startLoading();

    $('#modal-detalhes-realizado').modal("toggle");

    $('#modalAcumuladoTotal').val(1);

    setTimeout(function () {
        detalhesRealizadoMes(codigo_insumo, mes_realizado, obra_id);
    }, 1000);
}

$('#modal-detalhes-realizado-mes').on('hidden.bs.modal', function (e) {

    if ($('#modalAcumuladoTotal').val() == 1) {
        $('#modal-detalhes-realizado').modal("toggle");
        $('#modalAcumuladoTotal').val(0);
    }
});

/*
    Modal de projeções
*/
$(document).on('click', '.js-modal-projecao', function (e) {

    e.preventDefault();

    startLoading();

    $.ajax({
        url: $(this).attr('href')
    }).done(function (retorno) {

        stopLoading();
        $('#modal-body-projecao').html(retorno);
        $('#modal-projecao').modal("toggle");
    });
});

/*
    Modal de mostrar/ocultar colunas
*/
function modalColunas(abrir) {
    if (abrir) {
        $('#button_modal_colunas').attr('onclick', 'modalColunas(false)');
        $('#modal_colunas').css('display', '');
        $('.dt-button-background').fadeIn();
    } else {
        $('#button_modal_colunas').attr('onclick', 'modalColunas(true)');
        $('#modal_colunas').css('display', 'none');
    }
}

/*
    Realiza as validações para ocultar ou mostrar as colunas
*/
function ocultarMostrarColuna(coluna) {
    // trata variável global colunas_ocultas para ser enviada ao backend via ajax
    if ($('.coluna_' + coluna).is(":visible")) {
        colunas_ocultas[coluna] = true;
    } else {
        delete colunas_ocultas[coluna];
    }

    // atualiza colunas no backend por ajax
    setTimeout(function () {
        atualizarColunas(window.colunas_ocultas);
    }, 400);

    // Controla os headers
    if ($('.coluna_' + coluna + '_head').is(":visible")) {
        $('.coluna_' + coluna + '_head').hide();
    } else {
        $('.coluna_' + coluna + '_head').show();
    }

    // Controla as colunas que não tem valores
    if (coluna == 'evolucao_fisica' || coluna == 'obs' || coluna == 'tipo_projecao' || coluna == 'classificacao' || coluna == 'justificativa') {
        if ($('.coluna_' + coluna).is(":visible")) {
            $('.coluna_' + coluna).hide();
        } else {
            $('.coluna_' + coluna).show();
        }
    }

    // Controla as colunas com valores
    if ($('#visualizacao_ambos').is(":checked")) {
        $('.th_1_2').attr('colspan', 2);

        if ($('.coluna_' + coluna).is(":visible")) {
            $('.coluna_' + coluna).hide();
        } else {
            $('.coluna_' + coluna).show();
        }
    }

    if ($('#visualizacao_qtd').is(":checked")) {
        $('.th_1_2').attr('colspan', 1);

        if ($('.coluna_' + coluna + '.visao_qtd').is(":visible")) {
            $('.coluna_' + coluna + '.visao_qtd').hide();
        } else {
            $('.coluna_' + coluna + '.visao_qtd').show();
        }
    }

    if ($('#visualizacao_valor').is(":checked")) {
        $('.th_1_2').attr('colspan', 1);

        if ($('.coluna_' + coluna + '.visao_valor').is(":visible")) {
            $('.coluna_' + coluna + '.visao_valor').hide();
        } else {
            $('.coluna_' + coluna + '.visao_valor').show();
        }
    }

    // Controla as colunas de eficiência
    setTimeout(function () {
        if ($('.coluna_desvio').is(":visible") || $('.coluna_classificacao').is(":visible") || $('.coluna_justificativa').is(":visible")) {
            $('.coluna_eficiencia').show();
        } else {
            $('.coluna_eficiencia').hide();
        }

        // Controla os botões de colunas
        if ($('.coluna_' + coluna).is(":visible")) {
            $('#coluna_' + coluna).removeClass('active');
        } else {
            $('#coluna_' + coluna).addClass('active');
        }
    }, 1);

    if (Object.keys(window.colunas_ocultas).length == 16) {
        $('.gerencial_fixed').removeClass('col-md-5');
        $('.gerencial_fixed').addClass('col');
    } else if ($('.gerencial_fixed').hasClass('col')) {
        $('.gerencial_fixed').removeClass('col');
        $('.gerencial_fixed').addClass('col-md-5');
    }
}

/*
    Realiza as validações para ocultar as colunas
*/
function ocultarColuna(coluna) {
    // Controla os headers
    $('.coluna_' + coluna + '_head').hide();

    // Controla as colunas que não tem valores
    if (coluna == 'evolucao_fisica' || coluna == 'obs' || coluna == 'tipo_projecao' || coluna == 'classificacao' || coluna == 'justificativa') {
        $('.coluna_' + coluna).hide();
    }

    // Controla as colunas com valores
    if ($('#visualizacao_ambos').is(":checked")) {
        $('.th_1_2').attr('colspan', 2);

        $('.coluna_' + coluna).hide();
    }

    if ($('#visualizacao_qtd').is(":checked")) {
        $('.th_1_2').attr('colspan', 1);

        $('.coluna_' + coluna + '.visao_qtd').hide();
    }

    if ($('#visualizacao_valor').is(":checked")) {
        $('.th_1_2').attr('colspan', 1);

        $('.coluna_' + coluna + '.visao_valor').hide();
    }
}

function atualizarColunas(colunas_ocultas) {
    var colunas_ocultas = JSON.stringify(colunas_ocultas);

    $.ajax({
        type: 'post',
        url: '/gerencial/atualizarColunas',
        dataType: "json",
        data: {
            'colunas_ocultas': colunas_ocultas // variável global -> declarada no index.blade.php
        }
    }).done(function (data) {
        var status = typeof data['status'] !== 'undefined' ? data['status'] : 'error';
        var message = typeof data['message'] !== 'undefined' ? data['message'] : 'Erro ao executar ação. Contactar suporte';

        switch (status) {
            case 'ok':
                // console.log(data);
                break;
            case 'warning':
                swal("", message, "warning");
                break;
            case 'error':
                swal("", message, "error");
                break;
            default:
                swal("", 'Sem resposta do servidor. Entre em contato com o suporte', "warning");
                break;
        }
    });
}

/*
    Fecha modal com click no background
*/
$('.dt-button-background').click(function () {
    modalColunas(false);
    $(this).fadeOut();
});

$('#js-button-fechar-gerencial').on('click', function () {
    swal({
        title: "Deseja fechar a gerencial?",
        text: "Esta ação nao poderá ser desfeita!",
        confirmButtonColor: '#dd6b54',
        confirmButtonText: 'Sim, Fechar!',
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        type: 'warning'
    }, function () {
        startLoading();
        $('#js-form-fechar-gerencial').submit();
    });
});